import { Box } from "@mui/material";
import WorkflowDetails from "../../Components/workflowDetails";
import { useGetSharingWorkflowData } from "../../../../store/Apis/ShareApi";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {
  setSelectedWorkflowData,
  setSelectedWorkflowRun,
  WorkflowsType,
} from "../../../../store/one-query/workflowsSlice";
import { WorkflowType } from "../../../../Helper";
import { CopySharedWorkflow } from "../../Components/Shared/CopySharedWorkflow";
import { setShowSignPopup } from "../../../../store/one-query/chatsSlice";
import DuplicateTemplateModal from "../../Components/DuplicateTemplateModal";
import { useCloneWorkflow } from "../../../../store/Apis/WorkflowsApi";
import { WorkflowSharedView } from "../../../../Helpers/WorkflowHelper";

export const SharedWorkflowView = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const User = useAppSelector((s) => s.User);
  const workflowSlice = useAppSelector((s) => s.workflows);
  const { workflowRunId } = useParams<{ workflowRunId: string }>();
  const { data: sharingWorkflowData } = useGetSharingWorkflowData(
    workflowRunId || ""
  );
  const [showCopyWorkflowModal, setShowCopyWorkflowModal] = useState(false);
  const handleCloseCopyWorkflowModal = () => setShowCopyWorkflowModal(false);
  const { CloneWorkflow, isSuccess: isWorkflowCreated } = useCloneWorkflow();

  useEffect(() => {
    if (sharingWorkflowData && workflowSlice.textSuitesApps.length > 0) {
      const newApps = sharingWorkflowData?.workflowAppResults.map(
        (app: any, i: number) => {
          const runApp = workflowSlice.textSuitesApps?.find(
            (res: any) => res.id === app.appId
          );
          return {
            id: app?.workflowAppId || "",
            appId: runApp?.id || "",
            appType: runApp?.appType,
            inputType: runApp?.inputType,
            outputType: runApp?.outputType,
            suiteType: runApp?.suiteType,
            appOrder: i + 1,
            payload: {},
          };
        }
      );
      const currentWorkflowData: WorkflowsType = {
        id: sharingWorkflowData.workflowId || "",
        name: sharingWorkflowData.name || "",
        workflowType: WorkflowType.User,
        apps: newApps,
      };
      dispatch(setSelectedWorkflowData(currentWorkflowData));
      dispatch(setSelectedWorkflowRun(sharingWorkflowData));
    }
  }, [sharingWorkflowData, workflowSlice.textSuitesApps]);

  const handleShowCopySharedWorkflow = () => {
    if (!User.IsAuthenticated) {
      dispatch(
        setShowSignPopup({
          show: true,
          type: "Copy workflow",
          message:
            "Sign in for free to save your personal copy of this workflow.",
          btnTitle: "Sign In for Free",
          btnAction: "NavigateToLogin",
        })
      );
    } else {
      setShowCopyWorkflowModal(true);
    }
  };

  const handleCopyWorkflowAction = (workflowName: string) => {
    if (sharingWorkflowData) {
      CloneWorkflow({
        workflowId: sharingWorkflowData.workflowId,
        workflowName: workflowName,
      });
    }
  };

  useEffect(() => {
    if (isWorkflowCreated) navigate("/workflows");
  }, [isWorkflowCreated]);

  return (
    <Box className="shared-workflow-view">
      <Box sx={{ width: "100%" }}>
        <WorkflowDetails view={WorkflowSharedView} />
      </Box>
      <CopySharedWorkflow
        handleCopySharedWorkflow={handleShowCopySharedWorkflow}
      />
      {showCopyWorkflowModal && (
        <DuplicateTemplateModal
          modalTitle="Copy workflow"
          show={showCopyWorkflowModal}
          method={handleCopyWorkflowAction}
          handleClose={handleCloseCopyWorkflowModal}
          templateName={sharingWorkflowData?.name || ""}
        />
      )}
    </Box>
  );
};
